export enum FreeTrialRole {
  FREE_TRIAL_RECIPIENT = "FREE_TRIAL_RECIPIENT",
  FREE_TRIAL_GUEST = "FREE_TRIAL_GUEST",
}